import React from 'react';
import Select from 'react-select';

import './styles.scss';

const MultiDropdown = ({ label, options, defaultValue, placeholder, isLoading, onChange, outline, disabled = false }) => {
  const LoadingIndicator = () => {
    return (
      <div className="empty-message">
        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
      </div>
    );
  };

  return (
    <div className={`d-flex flex-column${outline ? ' outline' : ''}`}>
      {label && <label className="multi-dropdown__label">{label}</label>}
      <Select
        className="multi-dropdown-container"
        classNamePrefix="multi-dropdown"
        defaultValue={defaultValue}
        components={{ LoadingIndicator }}
        options={options}
        isLoading={isLoading}
        isDisabled={disabled}
        onChange={onChange}
        placeholder={placeholder}
        isMulti
        closeMenuOnSelect={false}
      />
    </div>
  );
};

export default MultiDropdown;
